import WorkflowIcon from '../../assets/img/icons/workflow.vue'
export const getMenuDashboard = [
  // ==================== SUPER ADMIN ====================
  // Dashboard (super_admin)
  // {
  //   category: 'Dashboard',
  //   title: 'Dashboard',
  //   roles: ['super_admin'],
  // },
  // {
  //   title: 'Dashboard',
  //   key: '__home_super_admin',
  //   url: '/',
  //   icon: 'fe fe-home',
  //   roles: ['super_admin'],
  // },

  // User category (super_admin only)
  {
    category: 'User',
    title: 'User',
    roles: ['super_admin', 'cabang'],
  },
  {
    title: 'Group Management',
    key: '__management_group',
    url: '/admin/groups',
    icon: 'fe fe-users',
    roles: ['super_admin'],
  },
  {
    title: 'User Management',
    key: '__management_user',
    url: '/admin/users',
    icon: 'fe fe-user',
    roles: ['super_admin', 'cabang'],
  },

  // ==================== ADMIN ====================
  // Dashboard (admin, ketua, sekretaris, bendahara, pengurus)
  {
    category: 'Dashboard',
    title: 'Dashboard',
    roles: ['admin', 'ketua', 'sekretaris', 'bendahara', 'pengurus'],
  },
  {
    title: 'Dashboard',
    key: '__home',
    url: '/',
    icon: 'fe fe-home',
    roles: ['admin', 'ketua', 'sekretaris', 'bendahara', 'pengurus'],
  },

  // ==================== PERSURATAN ====================
  // Persuratan category
  {
    category: 'Persuratan',
    title: 'Persuratan',
    roles: ['admin', 'ketua', 'sekretaris', 'bendahara', 'pengurus'],
  },
  // Admin: Surat Masuk, Surat Keluar, Pengaturan Surat
  {
    title: 'Surat Masuk',
    key: '__mail_in',
    url: '/surat-masuk',
    icon: 'fe fe-mail',
    roles: ['admin'],
  },
  {
    title: 'Surat Keluar',
    key: '__mail_out',
    url: '/surat-keluar',
    icon: 'fe fe-mail',
    roles: ['admin'],
  },
  {
    title: 'Pengaturan Surat',
    key: '__mail_setting_admin',
    url: '/pengaturan-surat',
    icon: 'fe fe-settings',
    roles: ['admin'],
  },
  // Ketua & Sekretaris: Surat Masuk, Surat Keluar, Disposisi Masuk, Verifikasi Surat, TTD Surat Digital, Pengaturan Surat
  {
    title: 'Surat Masuk',
    key: '__mail_in_ks',
    url: '/surat-masuk',
    icon: 'fe fe-mail',
    roles: ['ketua', 'sekretaris'],
  },
  {
    title: 'Surat Keluar',
    key: '__mail_out_ks',
    url: '/surat-keluar',
    icon: 'fe fe-mail',
    roles: ['ketua', 'sekretaris'],
  },
  {
    title: 'Disposisi Masuk',
    key: '__disposisi_masuk',
    url: '/disposisi-masuk',
    icon: 'fe fe-inbox',
    roles: ['ketua', 'sekretaris', 'bendahara', 'pengurus'],
  },
  {
    title: 'Verifikasi Surat',
    key: '__verifikasi_surat',
    url: '/verifikasi',
    icon: 'fe fe-check-circle',
    roles: ['ketua', 'sekretaris', 'bendahara', 'pengurus'],
  },
  {
    title: 'TTD Digital Surat',
    key: '__ttd',
    url: '/ttd-digital',
    icon: 'fe fe-edit-2',
    roles: ['ketua', 'sekretaris', 'bendahara', 'pengurus'],
  },
  {
    title: 'Pengaturan Surat',
    key: '__mail_setting',
    url: '/pengaturan-surat',
    icon: 'fe fe-settings',
    roles: ['ketua', 'sekretaris', 'bendahara', 'pengurus'],
  },

  // ==================== LAPORAN DINAS ====================
  {
    category: 'Laporan Dinas ',
    title: 'Laporan Dinas',
    roles: ['admin', 'ketua', 'sekretaris', 'bendahara', 'pengurus'],
  },
  // Ketua & Sekretaris: Laporan Dinas, Pencairan Uang Dinas
  {
    title: 'Laporan Dinas',
    key: '__laporan_dinas',
    url: '/laporan-dinas',
    icon: 'fe fe-file-text',
    roles: ['ketua', 'sekretaris', 'bendahara', 'pengurus'],
  },
  {
    title: 'Pencairan Uang Dinas',
    key: '__cash_out_dinas',
    url: '/cash-out',
    icon: 'fe fe-dollar-sign',
    roles: ['admin', 'ketua', 'sekretaris', 'bendahara', 'ketua', 'admin'],
  },

  // ==================== KALENDER ====================
  {
    category: 'Kalender',
    title: 'Kalender',
    roles: ['admin', 'ketua', 'sekretaris', 'bendahara', 'pengurus', 'cabang'],
  },
  {
    title: 'Kalender Event',
    key: '__calendar_event',
    url: '/event',
    icon: 'fe fe-calendar',
    roles: ['admin', 'ketua', 'sekretaris', 'bendahara', 'pengurus', 'cabang'],
  },
  {
    title: 'Notulensi',
    key: '__notulensi',
    url: '/notulensi',
    icon: 'fe fe-file-text',
    roles: ['admin', 'ketua', 'sekretaris', 'bendahara', 'pengurus', 'cabang'],
  },

  // ==================== USER MANAGEMENT (Admin only) ====================
  {
    category: 'User',
    title: 'User',
    roles: ['admin', 'ketua', 'sekretaris', 'bendahara', 'pengurus', 'cabang'],
  },

  {
    title: 'Manajemen User',
    key: '__management_user_admin',
    url: '/admin/users',
    icon: 'fe fe-users',
    roles: ['admin', 'cabang'],
  },
  {
    title: 'Pengaturan Profil',
    key: '__management_user_profile',
    url: '/akun/edit-profile',
    icon: 'fe fe-users',
    roles: [
      'admin',
      'ketua',
      'sekretaris',
      'bendahara',
      'pengurus',
      'cabang',
      'super_admin',
      'member',
    ],
  },

  // ==================== MOBILE CMS ====================
  {
    category: 'Mobile CMS',
    title: 'Mobile CMS',
    roles: ['mobile_cms_super_admin', 'mobile_cms_admin'],
  },
  {
    title: 'Admin Management',
    key: '__mobile_cms_admin_management',
    url: '/mobile-cms/admin-management',
    icon: 'fe fe-user-plus',
    roles: ['mobile_cms_super_admin'],
  },
  {
    title: 'User Management',
    key: '__mobile_cms_user_management',
    url: '/mobile-cms/user-management',
    icon: 'fe fe-users',
    roles: ['mobile_cms_super_admin'],
  },
  {
    title: 'Guidelines',
    key: '__mobile_cms_guidelines',
    url: '/mobile-cms/guidelines',
    icon: 'fe fe-book',
    roles: ['mobile_cms_admin'],
  },
  {
    title: 'Alur Algoritma Klinis',
    key: '__mobile_cms_algoritma',
    url: '/mobile-cms/algoritma-klinis',
    // icon: 'fe fe-share-2',
    icon: WorkflowIcon,
    // icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXdvcmtmbG93LWljb24gbHVjaWRlLXdvcmtmbG93Ij48cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB4PSIzIiB5PSIzIiByeD0iMiIvPjxwYXRoIGQ9Ik03IDExdjRhMiAyIDAgMCAwIDIgMmg0Ii8+PHJlY3Qgd2lkdGg9IjgiIGhlaWdodD0iOCIgeD0iMTMiIHk9IjEzIiByeD0iMiIvPjwvc3ZnPg==',
    roles: ['mobile_cms_admin'],
  },
  {
    title: 'Banner',
    key: '__mobile_cms_banner',
    url: '/mobile-cms/banner',
    icon: 'fe fe-image',
    roles: ['mobile_cms_admin'],
  },

  // ==================== Dashboard Membership ====================
  {
    category: 'Membership PERKI',
    title: 'Membership PERKI',
    roles: ['mobile_cms_admin'],
  },
  {
    title: 'Dashboard Member',
    key: '__mobile_cms_dashboard_member',
    url: '/mobile-cms/member-application/dashboard',
    icon: 'fe fe-home',
    roles: ['mobile_cms_admin'],
  },
  {
    title: 'Pendaftaran Member',
    key: '__mobile_cms_member_application',
    url: '/mobile-cms/member-application',
    icon: 'fe fe-file-text',
    roles: ['mobile_cms_admin'],
  },
  {
    title: 'Member PERKI',
    key: '__mobile_cms_member_perki',
    url: '/mobile-cms/member-perki',
    icon: 'fe fe-credit-card',
    roles: ['mobile_cms_admin'],
  },
]
